<template>
  <nav aria-label="Sections">
    <ul id="mySectionMenu">
      <li
        v-for="category in categories"
        :key="`${category.slug}`"
      >
        <RouterLink
          :to="category.slug"
          :title="category.title"
          class="block p-3 rounded-full group focus-a"
        >
          <span
            class="block h-2 md:h-3 w-2 md:w-3 rounded-full border border-black"
           :class="{
              'bg-black border-black': $route.params.category_id === category.slug,
              'group-hover:bg-black group-hover:border-black': !touch
            }"
          />
        </RouterLink>
      </li>
    </ul>
  </nav>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'FpNavDotsSlide',

  props: {
    categories: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    ...mapState([ 'touch', 'mobile' ]),
    ...mapGetters([ ])
  }
}
</script>
